import shopifyLogo from '../../images/shopify.svg'
import dynoLogo from '../../images/dyno-logo.svg'
import divyLogo from '../../images/divy-logo.svg'
import numoLogo from '../../images/numo-logo.svg'
import bylobyteLogo from '../../images/logos/bylobyte-logo-transparent-600-600.png'
import { useEffect } from 'react'

import './Navbar.css'

const Navbar = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 54;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      // Close the navbar after scrolling
      closeNavbar();
    }
  };

  // Function to close the navbar
  const closeNavbar = () => {
    const navbarCollapse = document.querySelector('#navbarsExample03');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  // Initialize Bootstrap collapse functionality
  useEffect(() => {
    // This ensures the collapse functionality is properly initialized
    const navbarToggler = document.querySelector('.navbar-toggler');
    if (navbarToggler) {
      navbarToggler.addEventListener('click', () => {
        const target = document.querySelector('#navbarsExample03');
        if (target) {
          target.classList.toggle('show');
        }
      });
    }
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand-sm px-5" aria-label="Third navbar example">
        <div className="container-fluid">
          <a className="navbar-brand d-flex align-items-center" href="/" onClick={closeNavbar}>
            <div className="logo-wrapper me-2">
              <img src={bylobyteLogo} alt="ByloByte" className="logo" />
            </div>
            <span className="navbar-brand-text">ByloByte</span>
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample03" aria-controls="navbarsExample03" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarsExample03">
            <ul className="navbar-nav mx-auto mb-sm-0">
              <li className="nav-item dropdown">
                <a className="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Products</a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item mb-2" href="#" onClick={(e) => { e.preventDefault(); scrollToSection('dyno-section'); }}>
                    <div className="dropdown-item-content d-flex align-items-center">
                      <div className="logo-wrapper flex-shrink-0">
                        <img src={dynoLogo} alt="Dyno" className="product-logo dyno-logo" />
                      </div>
                      <div className="dropdown-item-text d-flex flex-column justify-content-center">
                        <span className="fw-semibold app-name">Dyno Bulk Discount Codes</span>
                        <span className="dropdown-item-desc app-desc">Generate unlimited discount codes</span>
                      </div>
                    </div>
                  </a></li>
                  <li><a className="dropdown-item mb-2" href="#" onClick={(e) => { e.preventDefault(); scrollToSection('divy-section'); }}>
                    <div className="dropdown-item-content d-flex align-items-center">
                      <div className="logo-wrapper flex-shrink-0">
                        <img src={divyLogo} alt="Divy" className="product-logo divy-logo" />
                      </div>
                      <div className="dropdown-item-text d-flex flex-column justify-content-center">
                        <span className="fw-semibold app-name">Divy Auto Split Orders</span>
                        <span className="dropdown-item-desc app-desc">Easier fulfillment with split orders</span>
                      </div>
                    </div>
                  </a></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); scrollToSection('numo-section'); }}>
                    <div className="dropdown-item-content d-flex align-items-center">
                      <div className="logo-wrapper flex-shrink-0">
                        <img src={numoLogo} alt="Numo" className="product-logo numo-logo" />
                      </div>
                      <div className="dropdown-item-text d-flex flex-column justify-content-center">
                        <span className="fw-semibold app-name">Numo Decimal Discounts</span>
                        <span className="dropdown-item-desc app-desc">Decimal percentage values</span>
                      </div>
                    </div>
                  </a></li>
                </ul>
              </li>
              <li className="nav-item margin-below">
                <a className="nav-link" href="#" onClick={(e) => { e.preventDefault(); scrollToSection('contact-section'); }}>Contact</a>
              </li>
            </ul>
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link app-store-link" href="https://apps.shopify.com/partners/bylobyte" target="_blank" rel="noopener noreferrer" onClick={closeNavbar}>
                  <img src={shopifyLogo} alt="Shopify" className="shopify-logo" />
                  <span className="app-store-text">Shopify App Store</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="navbar-spacer"></div>
      {/* <div className="navbar-bottom-border"></div> */}
    </>
  );
}

export default Navbar;
